export default __webpack_public_path__ + "assets/images/035bc77afb5f4f8fd1fb406a7103a042.png";